import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_ASSETS_ENABLED = defineFcm('psf_share_assets_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-platypus',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'PSF share pages',
		description:
			'Controls whether the generated share visual (bestShareVisual) is displayed on the PSF Share page and PSF Promote-or-Share slide-up. Locale targeting is managed via the FCM admin panel.',
	});
